import { Col, Form, FormInstance, Input, Row } from "antd";
import { FC } from "react";

interface IIntlAddressEditorProps {
  form: FormInstance,
  baseName: string,
};

export const IntlAddressEditor: FC<IIntlAddressEditorProps> = ({ baseName, form }) => {
  return (
    <div className="IntlAddressEditor">

      <Row gutter={8}>
        <Col span={12}>
          <Form.Item
            name={[baseName, "address", 'address']}
            label='Address Line 1'
          >
            <Input />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={[baseName, "address", 'complement']}
            label='Address Line 2'
          >
            <Input />
          </Form.Item>
        </Col>

      </Row>

      <Row gutter={8}>
        <Col span={4}>
          <Form.Item
            name={[baseName, "address", 'zip_code']}
            label='ZIP Code'
          >
            <Input />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            name={[baseName, "address", 'city']}
            label='City'
          >
            <Input />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[baseName, "address", 'state']}
            label='State'
          >
            <Input />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[baseName, "address", 'country']}
            label='Country'
          >
            <Input />
          </Form.Item>
        </Col>


      </Row>
    </div>
  );
}
